import React from 'react';
import IconTicket from '../../images/IconTicket.jsx';

const TicketButton = ({ onClick }) => (
    <button
        onClick={onClick}
        className='flex items-center justify-center w-[60px] h-[60px] bg-white rounded-full border-2 border-solid border-theme1-primary shadow-subtle fixed right-8 bottom-8'
    >
        <IconTicket className='w-[30px] h-[30px] stroke-theme1-primary' />
    </button>
);

export default TicketButton;
